import { ExclamationCircleIcon } from '@nimbus-ds/icons';
import { FormField } from '@nimbus-ds/patterns';
import { InterfaceInput, InterfaceNameValue } from '@tiendanube/components';
import { InterfaceNameBooleanValue } from 'commons/types';
import { formatRfc, isValidRfc } from 'commons/utils/rfcValidation';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

interface RfcInputProps {
  readonly value: string;
  readonly name: string;
  readonly label: string;
  readonly helpText?: string;
  readonly appearance?: InterfaceInput['appearance'];
  readonly onChange: (
    data: InterfaceNameValue | InterfaceNameBooleanValue,
  ) => void;
}

function RfcInput({ value, onChange, name, label, helpText }: RfcInputProps) {
  const t = useTranslationPayments('nuvempagoSettings');

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const inputValue = event.target.value;
    const formattedValue = formatRfc(inputValue);

    onChange({ value: formattedValue, name });
  };

  const getAppearance = (): 'danger' | 'none' => {
    if (value.length === 0) return 'none';
    if (value.length >= 12 && !isValidRfc(value)) return 'danger';
    return 'none';
  };

  const getErrorMessage = (): string | null => {
    if (value.length === 0) return null;
    if (value.length < 12) return t('card.error.minLength');
    if (!isValidRfc(value)) return t('card.error.invalidRfc');
    return null;
  };

  const errorMessage = getErrorMessage();
  const finalHelpText = errorMessage || helpText;

  return (
    <FormField.Input
      label={label}
      helpText={finalHelpText}
      id="input-id"
      helpIcon={ExclamationCircleIcon}
      showHelpText={!!finalHelpText}
      name={name}
      type="text"
      placeholder="XXXX000101XXX"
      value={value}
      onChange={handleChange}
      appearance={getAppearance()}
    />
  );
}

export default RfcInput;
